//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.adapter

import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.AnyAdapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.IntAdapter
import com.apollographql.apollo.api.NullableAnyAdapter
import com.apollographql.apollo.api.StringAdapter
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.list
import com.apollographql.apollo.api.missingField
import com.apollographql.apollo.api.nullable
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.InspectionListQuery
import com.wintermar.inspection.graphql.type.InspectionStatus
import com.wintermar.inspection.graphql.type.adapter.InspectionStatus_ResponseAdapter
import kotlin.Any
import kotlin.Int
import kotlin.String
import kotlin.collections.List

public object InspectionListQuery_ResponseAdapter {
  public object Data : Adapter<InspectionListQuery.Data> {
    public val RESPONSE_NAMES: List<String> = listOf("inspectionList")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): InspectionListQuery.Data {
      var _inspectionList: InspectionListQuery.InspectionList? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _inspectionList = InspectionList.obj().fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return InspectionListQuery.Data(
        inspectionList = _inspectionList ?: missingField(reader, "inspectionList")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: InspectionListQuery.Data,
    ) {
      writer.name("inspectionList")
      InspectionList.obj().toJson(writer, customScalarAdapters, value.inspectionList)
    }
  }

  public object InspectionList : Adapter<InspectionListQuery.InspectionList> {
    public val RESPONSE_NAMES: List<String> = listOf("data", "totalCount")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): InspectionListQuery.InspectionList {
      var _data: List<InspectionListQuery.Data1>? = null
      var _totalCount: Int? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _data = Data1.obj().list().nullable().fromJson(reader, customScalarAdapters)
          1 -> _totalCount = IntAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return InspectionListQuery.InspectionList(
        `data` = _data,
        totalCount = _totalCount ?: missingField(reader, "totalCount")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: InspectionListQuery.InspectionList,
    ) {
      writer.name("data")
      Data1.obj().list().nullable().toJson(writer, customScalarAdapters, value.`data`)

      writer.name("totalCount")
      IntAdapter.toJson(writer, customScalarAdapters, value.totalCount)
    }
  }

  public object Data1 : Adapter<InspectionListQuery.Data1> {
    public val RESPONSE_NAMES: List<String> =
        listOf("id", "templateId", "inspectionName", "vesselName", "conductedAt", "lastUpdatedAt", "status", "totalQuestions", "answeredQuestions")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): InspectionListQuery.Data1 {
      var _id: Any? = null
      var _templateId: Any? = null
      var _inspectionName: String? = null
      var _vesselName: String? = null
      var _conductedAt: Any? = null
      var _lastUpdatedAt: Any? = null
      var _status: InspectionStatus? = null
      var _totalQuestions: Int? = null
      var _answeredQuestions: Int? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _id = AnyAdapter.fromJson(reader, customScalarAdapters)
          1 -> _templateId = AnyAdapter.fromJson(reader, customScalarAdapters)
          2 -> _inspectionName = StringAdapter.fromJson(reader, customScalarAdapters)
          3 -> _vesselName = StringAdapter.fromJson(reader, customScalarAdapters)
          4 -> _conductedAt = AnyAdapter.fromJson(reader, customScalarAdapters)
          5 -> _lastUpdatedAt = NullableAnyAdapter.fromJson(reader, customScalarAdapters)
          6 -> _status = InspectionStatus_ResponseAdapter.fromJson(reader, customScalarAdapters)
          7 -> _totalQuestions = IntAdapter.fromJson(reader, customScalarAdapters)
          8 -> _answeredQuestions = IntAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return InspectionListQuery.Data1(
        id = _id ?: missingField(reader, "id"),
        templateId = _templateId ?: missingField(reader, "templateId"),
        inspectionName = _inspectionName ?: missingField(reader, "inspectionName"),
        vesselName = _vesselName ?: missingField(reader, "vesselName"),
        conductedAt = _conductedAt ?: missingField(reader, "conductedAt"),
        lastUpdatedAt = _lastUpdatedAt,
        status = _status ?: missingField(reader, "status"),
        totalQuestions = _totalQuestions ?: missingField(reader, "totalQuestions"),
        answeredQuestions = _answeredQuestions ?: missingField(reader, "answeredQuestions")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: InspectionListQuery.Data1,
    ) {
      writer.name("id")
      AnyAdapter.toJson(writer, customScalarAdapters, value.id)

      writer.name("templateId")
      AnyAdapter.toJson(writer, customScalarAdapters, value.templateId)

      writer.name("inspectionName")
      StringAdapter.toJson(writer, customScalarAdapters, value.inspectionName)

      writer.name("vesselName")
      StringAdapter.toJson(writer, customScalarAdapters, value.vesselName)

      writer.name("conductedAt")
      AnyAdapter.toJson(writer, customScalarAdapters, value.conductedAt)

      writer.name("lastUpdatedAt")
      NullableAnyAdapter.toJson(writer, customScalarAdapters, value.lastUpdatedAt)

      writer.name("status")
      InspectionStatus_ResponseAdapter.toJson(writer, customScalarAdapters, value.status)

      writer.name("totalQuestions")
      IntAdapter.toJson(writer, customScalarAdapters, value.totalQuestions)

      writer.name("answeredQuestions")
      IntAdapter.toJson(writer, customScalarAdapters, value.answeredQuestions)
    }
  }
}
